import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@optools/components/ui/select';
import { BtcGameAsset } from '@optools/services/operator-gateway/btc/types';
import { AssetState } from '@optools/services/operator-gateway/types/generated/graphql';
import { Circle, CircleAlert, CircleDot, CircleX } from 'lucide-react';
import { ReactNode } from 'react';

const OPTIONS = Object.values(AssetState);
OPTIONS.sort((a, b) => b.localeCompare(a));

const ICON_MAP: Record<AssetState, ReactNode> = {
  [AssetState.DEGRADED]: <CircleAlert className="size-4" />,
  [AssetState.ERROR]: <CircleX className="size-4" />,
  [AssetState.OFF]: <Circle className="size-4" />,
  [AssetState.ON]: <CircleDot className="size-4" />,
};

export interface AssetStateSelectProps {
  asset: BtcGameAsset;
  isPending: boolean;
  onStateChange: (asset: BtcGameAsset, state: AssetState) => void;
}

export function AssetStateSelect({ asset, isPending, onStateChange }: AssetStateSelectProps) {
  const handleStateChange = (state: AssetState) => {
    onStateChange(asset, state);
  };

  return (
    <Select disabled={isPending} value={asset.state} onValueChange={handleStateChange}>
      <SelectTrigger aria-label="Asset State" className="w-full capitalize" loading={isPending}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {OPTIONS.map((state) => (
          <SelectItem key={state} className="capitalize" value={state}>
            <div className="flex items-center gap-2">
              {ICON_MAP[state]}
              {state.toLocaleLowerCase()}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
